import React = require('react');
import { Col, ControlLabel, FormGroup } from 'react-bootstrap';
import { Field } from 'redux-form';
import FieldFormControl from '../../../../../../../../components/FieldFormControl';
import AlternativeDatePicker from '../../../../../../../../components/AlternativeDatePicker';
import {
  validateIsFutureDate,
  isRequired,
  isValidDate,
  minTripDuration,
  singleMaxTripDuration
} from '../../../../../../../../util/validators';
import { addDays, parse } from 'date-fns';

interface IEndDateSelectorProps {
  startDate: string,

  renderDefinition(name: string, useProvidedString?: boolean): any;
}

export const EndDateSelector = ({ startDate, renderDefinition }: IEndDateSelectorProps) => {

  const onClickEvent = (e) => {
    e.preventDefault();
    e.stopPropagation();
  }

  return (
    <div>
      <div className="date-container">
        <div className={'flex--50 pt-10 pb-10'} onClick={onClickEvent}>
          Return date {renderDefinition('travel_dates')}
        </div>
        <div className="date-picker flex--stretch pt-10 pb-10" onClick={onClickEvent}>
          <div className="alternative-date-picker">
            <div className="field end-date-input">
              <Field
                name="endDate"
                type="masked-date"
                inputmode="numeric"
                placeholder="dd/mm/yyyy"
                component={FieldFormControl}
              />
            </div>
            <div className="icon">
              <Field
                name="endDate"
                minDate={startDate ? addDays(parse(startDate, 'dd/MM/yyyy', new Date()), 1) : new Date()}
                maxDate={
                  parse(startDate, 'dd/MM/yyyy', new Date()) < addDays(new Date(), 91) ?
                    addDays(new Date(), 365) :
                    addDays(new Date(), 455)
                }
                component={AlternativeDatePicker}
                validate={[
                  isRequired,
                  validateIsFutureDate,
                  isValidDate,
                  minTripDuration(startDate),
                  singleMaxTripDuration(startDate),
                ]}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
